module.exports = __webpack_public_path__ + "img/useFlow-big-bg.618f0d1.png";